<template>
    <button @click="reset()" type="button" :class="{'btn-success': enable, 'btn-danger': ! enable, }"
            class="btn btn-sm btn-block">
        {{text}}
    </button>
</template>
<script>
import {Comandos, Concox} from '../../class';
    import {Bus} from '../../class/bus';
    export default {
        props: {
            text: {
                default: "SZCS#GT06IEXVOL=2"
            },
            id_rastreador: {
                "default": null
            },
            enable: {
                default: true
            }
        },
        methods: {
            async reset () {
                await Concox.habilitarTensao(this.id_rastreador, this.enable);
                Bus.$emit('comandos');
            }
        }
    }
</script>
